import React from 'react';
import { useToolbarOverflowMenuClose } from './toolbar/Toolbar';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { MenuItem } from '../../components/Menu';
import copyIcon from '../../icons/non-prefilled/16x16/copy.svg';
import { UIActions } from '../../ui/uiSlice';

interface CopyLinkMenuItemProps {
  link: string;
  children?: string;
}

const CopyLinkMenuItem = ({ link, children }: CopyLinkMenuItemProps) => {
  const closeOverflowMenu = useToolbarOverflowMenuClose();
  const dispatch = useAppDispatch();

  return (
    <MenuItem
      icon={copyIcon}
      onClick={async () => {
        await navigator.clipboard.writeText(link);
        dispatch(
          UIActions.pushToast({
            level: 'success',
            message: 'Link copied',
          }),
        );
        closeOverflowMenu();
      }}
      testId="copyLinkMenuItem"
    >
      {children ?? 'Copy link'}
    </MenuItem>
  );
};

export default CopyLinkMenuItem;
